import type { ReactNode } from 'react'

interface OutlineButtonProps {
  children: ReactNode
  onClick?: () => void
  disabled?: boolean
  /** 열 폭을 채운다. 목록 맨 아래에서 홀로 서는 자리가 이 모양이다. */
  block?: boolean
  /**
   * 보이는 라벨과 다른 접근성 이름.
   *
   * 같은 라벨의 버튼이 목록에 여럿 설 때만 준다. 소리로 듣는 사람이 추가를 여러 번 듣고
   * 어느 것인지 가리지 못하는 자리가 그렇다.
   */
  label?: string
  /** 왕복이 도는 중. 자리를 그대로 두고 상태만 알린다. */
  busy?: boolean
}

/**
 * 면 없이 테두리로 서는 버튼.
 *
 * 안내 블록의 액션과 로그아웃이 이 종류다. 컨트롤을 알아보는 유일한 단서가 되는 선이라
 * ink-muted를 쓴다. border는 면과 면을 가르는 장식 선 전용이다.
 *
 * 라벨은 ink다. 흐린 색으로 낮추면 읽는 글과 누르는 자리가 같은 무게로 보인다.
 */
export function OutlineButton({
  children,
  onClick,
  disabled,
  block,
  label,
  busy,
}: OutlineButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      aria-busy={busy}
      className={`pressable border-ink-muted text-ink rounded-card min-h-11 border px-[18px] text-[15px] disabled:opacity-60 ${
        block ? 'w-full' : ''
      }`}
    >
      {children}
    </button>
  )
}
